import { normalizeMapsFreeText } from "~/lib/utils/normalize-maps-input";

/**
 * First-party CityLinks cities and their Places region IDs.
 *
 * Seeded once from Places Autocomplete (New) with `includedPrimaryTypes: ["(regions)"]`
 * and language `de`. Runtime CMS/`?loc=` resolution must use this table — never Google.
 */
export const CMS_LOCATION_CATALOG: Readonly<Record<string, string>> = {
  berlin: "ChIJAVkDPzdOqEcRcDteW0YgIQQ",
  hamburg: "ChIJuRMYfoNhsUcRoDrWe_I9JgQ",
  münchen: "ChIJ2V-Mo_l1nkcRfZixfUq4DAE",
  köln: "ChIJ5S-raZElv0cR8HcqSvxgJwQ",
  "frankfurt am main": "ChIJxZZwR28JvUcRAMawKVBDIgQ",
  düsseldorf: "ChIJB1lG8XvJuEcRsHMqSvxgJwQ",
  stuttgart: "ChIJ04-twTTbmUcR5M-RdxzB1Xk",
  leipzig: "ChIJcywPIBj4pkcRUvW0udKA35M",
  dortmund: "ChIJEXrwv2AXuUcRUIdUMYHyJwQ",
  bremen: "ChIJNePuDBAosUcRUd83-VyI6MI",
  essen: "ChIJOfarlrfCuEcRnSytpBHhAGo",
  dresden: "ChIJqdYaECnPCUcRsP6IQsuxIQQ",
  nürnberg: "ChIJ0xy2ta5Xn0cRtyGMqYWvXd0",
  hannover: "ChIJhU9JTVELsEcRIEeslG2sJQQ",
  regensburg: "ChIJ9y4icpjBn0cREMs3CaQlHQQ",
};

export function lookupCmsLocationPlaceId(
  label: string,
): string | undefined {
  const normalized = normalizeMapsFreeText(label);
  if (!normalized || !Object.hasOwn(CMS_LOCATION_CATALOG, normalized)) {
    return undefined;
  }
  return CMS_LOCATION_CATALOG[normalized];
}

export type CityLinkSearch = {
  location?: string[];
  placeIds?: string[];
  filters?: {
    locationType?: number[];
    occasion?: number[];
  };
};

/**
 * Canonical `/search` params for a CityLinks href.
 * Unknown cities omit location/placeIds so search does not geocode them.
 */
export function buildCityLinkSearch(
  city: string,
  opts?: { locationType?: number; occasion?: number },
): CityLinkSearch {
  const placeId = lookupCmsLocationPlaceId(city);
  const search: CityLinkSearch = {};

  if (placeId) {
    search.location = [city];
    search.placeIds = [placeId];
  }

  if (opts?.locationType != null) {
    search.filters = { ...search.filters, locationType: [opts.locationType] };
  }
  if (opts?.occasion != null) {
    search.filters = { ...search.filters, occasion: [opts.occasion] };
  }

  return search;
}
